$(document).ready(function(){
  $('#shopify-section-template--14352056320057__image_banner a, .pd-detail-infoWrap a, #Banner-template--14352056254521__16394902046b8f57d3 a, .shop_banner_wrap a, .faq_banner_wrap a, #shop_banner a, #shopify-section-template--14383585919033__main a').click(function() {
    var hdhight = $("#but-header").height() + 10;
    var getElem = $(this).attr('href');
    var targetDistance = hdhight;
    if ($(getElem).length) {
      var getOffset = $(getElem).offset().top;
      $('html,body').animate({
        scrollTop: getOffset - targetDistance
      }, 1000);
    }
    return false;
  });

  $("[data-but-header]").on("click", "button.but-link-1", function() {
    if($(this).closest(".but-dropdown-1").hasClass("open")){
      $(this).closest(".but-dropdown-1").removeClass("open");
      setTimeout(() => {
        $(this).closest(".but-dropdown-1").find("div").addClass("hidden");  
        $(this).closest(".but-dropdown-1").css("border-color", "transparent") 
      }, 600);
    }else{
      $(this).closest(".but-dropdown-1").find("div").removeClass("hidden");
      setTimeout(() => {
        $(this).closest(".but-dropdown-1").addClass("open");
        $(this).closest(".but-dropdown-1").css("border-color", "#FFF") 
      }, 60);
    }
  });

  $(".but-wrap-menu").click(function() {
    if($(".but-menu-open").hasClass("show")){
      $(".but-menu-open").removeClass("show")
      $(".but-menu-open").css("opacity", "0")
      setTimeout(() => {
        $(".but-menu-open").css("display", "none")  
      }, 600);
    }else{
      $(".but-menu-open").addClass("show")
      $(".but-menu-open").css("display", "block")
      setTimeout(() => {
        $(".but-menu-open").css("opacity", "1")
      }, 60);
    }   
  });


  const aScroll = document.getElementById("auto-scroll")
  
  if(aScroll){
    const y = aScroll.getBoundingClientRect().top + window.scrollY;
    setTimeout(() => {
      console.log("Scroll")
      window.scroll({
        top: y - 500,
        behavior: 'instant'
      });
    }, 800)
  }

  if((document.location.href).includes("#")){
    setTimeout(() => {
      goToLink(document.location.href)
    }, 200)
  }
});

function setHeaderFIxed(){
  const h = $("#bus-header-message").height() || 50
  if(document.documentElement.scrollTop >= h)
      $("#but-header").addClass("bus-header--fixed")
  else
      $("#but-header").removeClass("bus-header--fixed")
}

function resizeSlide(){
  const maxH = $(".but-mask-slider").height()
  $(".w-slide").css({"height": maxH})
}

window.addEventListener('scroll', setHeaderFIxed, true);
window.addEventListener('resize', setHeaderFIxed, true);
window.addEventListener('resize', resizeSlide, true);

$(() => {
  resizeSlide();
  setHeaderFIxed();
})

function goTo(hash){
  let hashId = hash.split("#")
  hashId = (hashId.length > 1) ? hashId.pop() : hash
    console.log(hashId)
  var targetDistance = $("#but-header").height() + 10;
  var getOffset = $("#"+hashId).offset().top;
  $('html,body').animate({
    scrollTop: getOffset - targetDistance
  }, 1000);
}

function goToLink(hash){
  let hashId = hash.split("#")
  hashId = (hashId.length > 1) ? hashId.pop() : hash

  const aScroll = document.getElementById("section-"+hashId)
  
  if($(".but-menu-open").hasClass("show")){
    $(".but-menu-open").removeClass("show")
    $(".but-menu-open").css("opacity", "0")
    setTimeout(() => {
      $(".but-menu-open").css("display", "none")  
    }, 600);
  }

  if(aScroll){
    
    var targetDistance = $("#but-header").height();
    let y = aScroll.getBoundingClientRect().top + window.scrollY;
    window.scroll({
      top: y - targetDistance + 40,
      behavior: 'smooth'
    });

    setTimeout(() =>{
      y = aScroll.getBoundingClientRect().top + window.scrollY;
      window.scroll({
        top: y - targetDistance + 40,
        behavior: 'smooth'
      });
    }, 700)
  }else{
    console.log(hash)
    location.href = hash
  }
}